import styled, { createGlobalStyle } from 'styled-components';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';

export const GliaGlobalStyle = createGlobalStyle`
  #salemove .sm-visitor-app {
    right: 480px !important;
  }
`;

export const Wrapper = styled(Box)({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'hidden',
});

export const TableHeader = styled.thead(({ theme }) => ({
  borderTop: `1px solid ${theme.colors.neutral['200']}`,
}));
